import translit from "cyrillic-to-translit-js";
import axios from "axios";
// import { translate } from "@/api/translate.api";

export const themesTable = [
  {
    value: "id",
    name: "ID",
    editable: false,
    component: "VTextField",
    size: "sm",
    validator: (value) => {
      return value;
    },
    onInput: () => {},
    length: "",
  },
  {
    value: "alias",
    name: "Alias",
    editable: true,
    component: "VTextField",
    size: "sm",
    type: "varchar",
    length: "100",
    validator() {
      return true;
    },
    onInput() {},
  },
  {
    value: "sort",
    name: "Сортировка",
    editable: true,
    component: "VTextField",
    length: "",
    size: "sm",
    validator: () => {
      return true;
    },
    onInput: () => {},
  },
  {
    value: "parent_id",
    name: "Родительский элемент",
    editable: true,
    size: "sm",
    length: "",
    component: "VTextField",
    selectBox: true,
    selectComponent: "VTreeview",
    selectLoadedData: [],
    validator: (value) => {
      return value;
    },
    onInput: () => {},
    async fetchSelectData() {
      const { data } = await axios.get("/themes/get_parent_tree");
      this.selectLoadedData = data;
    },
  },
  {
    value: "title_ru",
    name: "Название (рус.)",
    editable: true,
    component: "VTextField",
    size: "md",
    type: "varchar",
    length: "100",
    style: {
      fontSize: "19px",
      fontWeight: 500,
      color: "grey",
    },
    validator: (value) => {
      return value;
    },
    onInput() {
      this.editingObject.alias = translit({ preset: "ru" })
        .transform(this.editingObject.title_ru, "_")
        .toLowerCase();

      //   translate("ru-uk", this.editingObject.title_ru).then(({ data }) => {
      //     this.editingObject.title_ua = data;
      //   });
    },
  },
  //   {
  //     value: "title_ua",
  //     name: "Название (укр.)",
  //     editable: true,
  //     component: "VTextField",
  //     size: "md",
  //     type: "varchar",
  //     length: "100",
  //     style: {
  //       fontSize: "19px",
  //       fontWeight: 500,
  //       color: "grey",
  //     },
  //     validator: (value) => {
  //       return value;
  //     },
  //     onInput: () => {},
  //   },
  {
    value: "title_full_ru",
    name: "Полное название (рус.)",
    editable: true,
    component: "VTextField",
    size: "md",
    type: "varchar",
    length: "100",
    style: {
      fontSize: "19px",
      fontWeight: 500,
      color: "grey",
    },
    validator: (value) => {
      return value;
    },
    onInput: () => {},
  },
  //   {
  //     value: "title_full_ua",
  //     name: "Полное название (укр.)",
  //     editable: true,
  //     component: "VTextField",
  //     size: "md",
  //     type: "varchar",
  //     length: "100",
  //     style: {
  //       fontSize: "19px",
  //       fontWeight: 500,
  //       color: "grey",
  //     },
  //     validator: (value) => {
  //       return value;
  //     },
  //     onInput: () => {},
  //   },
  {
    value: "description_ru",
    name: "Описание (рус.) статья темы",
    editable: true,
    component: "VueEditor",
    size: "md",
    length: "",
    type: "text",
    validator: (value) => {
      return value;
    },
    onInput: () => {
      //   translate("ru-uk", this.editingObject.description_ru).then(({ data }) => {
      //     this.editingObject.description_ua = data;
      //   });
    },
  },
  //   {
  //     value: "description_ua",
  //     name: "Описание (укр.) - статья темы",
  //     editable: true,
  //     component: "VueEditor",
  //     size: "md",
  //     validator: (value) => {
  //       return value;
  //     },
  //     onInput: () => {},
  //     type: "text",
  //     length: "",
  //   },
  //   {
  //     value: "text_ru",
  //     name: "Текст (рус.) - [*Только для подтем] - добавляется к описанию товара",
  //     editable: true,
  //     component: "VueEditor",
  //     type: "text",
  //     length: "",
  //     size: "md",
  //     validator: (value) => {
  //       return value;
  //     },
  //     onInput: () => {
  //       //   translate("ru-uk", this.editingObject.text_ru).then(({ data }) => {
  //       //     this.editingObject.text_ua = data;
  //       //   });
  //     },
  //   },
  //   {
  //     value: "text_ua",
  //     name: "Текст (укр.) - [*Только для подтем] - добавляется к описанию товара",
  //     editable: true,
  //     component: "VueEditor",
  //     type: "text",
  //     length: "",
  //     size: "md",
  //     validator: (value) => {
  //       return value;
  //     },
  //     onInput: () => {},
  //   },
  {
    value: "publish",
    name: "Публикация",
    editable: true,
    component: "VCheckbox",
    type: "tinyint",
    length: "",
    size: "sm",
    validator: (value) => {
      return value;
    },
    onInput: () => {},
  },
];
